export { TemplateSettings } from "./TemplateSettings";



// WEBPACK FOOTER //
// ./src/pages/admin/template-editor/components/template-settings/index.ts